{
  "January": "January",
  "February": "February",
  "March": "March",
  "April": "April",
  "May": "May",
  "June": "June",
  "July": "July",
  "August": "August",
  "September": "September",
  "October": "October",
  "November": "November",
  "December": "December",
  "JanAbbr": "Jan",
  "FebAbbr": "Feb",
  "MarAbbr": "Mar",
  "AprAbbr": "Apr",
  "MayAbbr": "May",
  "JunAbbr": "Jun",
  "JulAbbr": "Jul",
  "AugAbbr": "Aug",
  "SepAbbr": "Sep",
  "OctAbbr": "Oct",
  "NovAbbr": "Nov",
  "DecAbbr": "Dec",
  "Today": "Today",
  "Yesterday": "Yesterday",
  "ThisWeek": "This Week",
  "LastWeek": "Last Week",
  "Last7Days": "Last 7 Days",
  "ThisMonth": "This Month",
  "LastMonth": "Last Month",
  "Su": "Su",
  "Mo": "Mo",
  "Tu": "Tu",
  "We": "We",
  "Th": "Th",
  "Fr": "Fr",
  "Sa": "Sa"
}
